export enum PeppolDocumentFilter {
  Unconnected = 'Unconnected',
  Connected = 'Connected',
}

export enum PeppolListScope {
  Inbox = 'Inbox',
  Outbox = 'Outbox',
  Archive = 'Archive',
}
